import { createSelector } from 'reselect';
import getAllBackgrounds from './getAllBackgrounds';

/** The id of the background `getSceneSize` derives its dimensions from — the first background
 * with a stored `width`/`height`. Used by garment auto-placement to identify which background's
 * `garmentMarkers` apply. */
const getSceneDefiningBackgroundId = createSelector([getAllBackgrounds], (backgrounds) => {
    const firstBackgroundWithSize = backgrounds.find((background) => background.width && background.height);
    return firstBackgroundWithSize?.id;
});

export default getSceneDefiningBackgroundId;
